import { sortArrayOfObj, monthDifference } from '../utils/utils';

export function highlightColumn(pointSpread, injurySpread) {
	if (pointSpread > 0) {
		if (injurySpread > 0) {
			if (pointSpread > injurySpread) {
				return 'home';
			} else {
				return 'away';
			}
		} else {
			return 'home';
		}
	} else if (pointSpread > injurySpread) {
		return 'home';
	} else {
		return 'away';
	}
}

export function highlightColumnColor(percent, highlightClass, type, strokeColor) {
	console.log(type,'teamhealth',highlightClass,!strokeColor)
	if (type === 'teamhealth' || !type) {
		console.log("teamhealth.....")

		if (percent == null || percent === undefined || percent >= 8) {
			return !strokeColor ? `${highlightClass}DarkGreen` : '#04B876';
		} else if (percent >= 6) {
			return !strokeColor ? `${highlightClass}Green` : '#74ad06';
		} else if (percent >= 4) {
			return !strokeColor ? `${highlightClass}Yellow` : '#d6c605';
		} else {
			return !strokeColor ? `${highlightClass}Red` : '#c71717';
		}
	} else if (type === 'playerhealth') {
		console.log("PlayerHealth")
		if (percent == null || percent === undefined || percent >= 80.01) {
			return !strokeColor ? `${highlightClass}DarkGreen` : '#04B876';
		} else if (percent >= 60.01 && percent <= 80) {
			return !strokeColor ? `${highlightClass}Green` : '#74ad06';
		} else if (percent >= 40.01 && percent <= 60) {
			return !strokeColor ? `${highlightClass}Yellow` : '#d6c605';
		} else {
			return !strokeColor ? `${highlightClass}Red` : '#c71717';
		}
	} else if (type === 'irc') {
		if (percent >= 0 && percent < 14) {
			return !strokeColor ? `${highlightClass}Green` : '#74ad06';
		} else if (percent >= 14 && percent < 25) {
			return !strokeColor ? `${highlightClass}Yellow` : '#d6c605';
		} else {
			return !strokeColor ? `${highlightClass}Red` : '#c71717';
		}
	} else if (type === 'hpf') {
		if (percent >= 81 && percent <= 100) {
			return !strokeColor ? `${highlightClass}Green` : '#74ad06';
		} else if (percent >= 66 && percent < 81) {
			return !strokeColor ? `${highlightClass}DarkGreen` : '#04B876';
		} else if (percent >= 41 && percent < 66) {
			return !strokeColor ? `${highlightClass}Yellow` : '#d6c605';
		} else {
			return !strokeColor ? `${highlightClass}Red` : '#c71717';
		}
	}
}

export function highlightTextColor(percent, highlightClass, type, strokeColor) {
	if (type === 'teamhealth' || !type) {
		if (percent == null || percent === undefined || percent >= 7) {
			return '#04B876';
		} else if (percent < 7 && percent >= 4) {
			return '#74ad06';
		} else if (percent < 4 && percent >= 2) {
			return '#d6c605';
		} else {
			return '#c71717';
		}
	} else if (type === 'playerhealth') {
		if (percent == null || percent === undefined || percent >= 80.01) {
			return '#04B876';
		} else if (percent >= 60.01 && percent <= 80) {
			return '#74ad06';
		} else if (percent >= 40.01 && percent <= 60) {
			return '#d6c605';
		} else {
			return '#c71717';
		}
	} else if (type === 'irc') {
		if (percent >= 0 && percent < 14) {
			return '#74ad06';
		} else if (percent >= 14 && percent < 25) {
			return '#d6c605';
		} else {
			return '#c71717';
		}
	} else if (type === 'hpf') {
		if (percent >= 81 && percent <= 100) {
			return '#74ad06';
		} else if (percent >= 66 && percent < 81) {
			return '#04B876';
		} else if (percent >= 41 && percent < 66) {
			return '#d6c605';
		} else {
			return '#c71717';
		}
	}
}

export function checkHealthScoreStatus(percent, categories, type) {
	console.log(percent,'percent....',categories, type)
	if (type === 'player') {
		if (percent >= 80.01) {
			console.log("Optimal")
			return {
				status: 'OPTIMAL',
				background: 'cardSpreadDarkGreen',
				players: categories
			};
		} else if (percent >= 60.01 && percent <= 80) {
			return {
				status: 'POSITIVE',
				background: 'cardSpreadGreen',
				players: categories
			};
		} else if (percent >= 40.01 && percent <= 60) {
			return {
				status: 'RISKY',
				background: 'cardSpreadYellow',
				players: categories
			};
		} else {
			return {
				status: 'HIGH RISK',
				background: 'cardSpreadRed',
				players: categories
			};
		}
	} else if (type === 'team' || !type) {
		if (percent == null || percent === undefined) {
			return {
				status: 'N/A',
				background: 'cardSpreadDarkGreen',
				players: categories
			};
		} else if (percent >= 8) {
			return {
				status: 'OPTIMAL',
				background: 'cardSpreadDarkGreen',
				players: categories
			};
		} else if (percent >= 6) {
			return {
				status: 'GOOD',
				background: 'cardSpreadGreen',
				players: categories
			};
		} else if (percent >= 4) {
			return {
				status: 'MODERATE',
				background: 'cardSpreadYellow',
				players: categories
			};
		} else {
			return {
				status: 'POOR',
				background: 'cardSpreadRed',
				players: categories
			};
		}
	}
}



export function getPlayerCategories(playerArr, type, healthScores, team) {
	let categories;
	console.log(playerArr,'playerArr')
	if (type === 'offensiveskills') {
		categories = playerArr.filter((x) => {
			const pos = x.position_map || x.position;
			return pos === 'QB' || pos === 'WR' || pos === 'RB' || pos === 'TE' || pos === 'FB';
		});
		categories = categories.sort((a, b) => (a.depth_chart_order < b.depth_chart_order ? 1 : b.depth_chart_order < a.depth_chart_order ? -1 : 0));
		return checkHealthScoreStatus(team?.offensive_skills_avg_rounded, categories);
	} else if (type === 'offensiveline') {
		categories = playerArr.filter((x) => {
			const pos = x.position_map || x.position;
			return pos === 'G' || pos === 'C' || pos === 'T' ||
				pos === 'OL' || pos === 'OT' || pos === 'LS' || pos === 'OG';
		});
		categories = categories.sort((a, b) => (a.depth_chart_order < b.depth_chart_order ? 1 : b.depth_chart_order < a.depth_chart_order ? -1 : 0));
		return checkHealthScoreStatus(team?.offensive_line_avg_rounded, categories);
	} else if (type === 'defensiveline') {
		categories = playerArr.filter((x) => {
			const pos = x.position_map || x.position;
			return pos === 'DT' || pos === 'LB' || pos === 'OLB' || pos === 'MLB' || pos === 'DE' ||
				pos === 'DL' || pos === 'NT' || pos === 'ILB' || pos === 'EDGE' || pos === 'SLB';
		});
		categories = categories.sort((a, b) => (a.depth_chart_order < b.depth_chart_order ? 1 : b.depth_chart_order < a.depth_chart_order ? -1 : 0));
		return checkHealthScoreStatus(team?.defensive_line_avg_rounded, categories);
	} else if (type === 'defensivesecondary') {
		categories = playerArr.filter((x) => {
			const pos = x.position_map || x.position;
			return pos === 'SS' || pos === 'FS' || pos === 'CB' ||
				pos === 'DB' || pos === 'S' || pos === 'SAF' || pos === 'SPUR';
		});
		categories = categories.sort((a, b) => (a.depth_chart_order < b.depth_chart_order ? 1 : b.depth_chart_order < a.depth_chart_order ? -1 : 0));
		return checkHealthScoreStatus(team?.defensive_secondary_avg_rounded, categories);
	} else if (type === 'rebounders') {
		categories = [];
		return checkHealthScoreStatus(team?.rebounders_avg_adjusted_nba, categories);
	} else if (type === 'scorers') {
		categories = [];
		return checkHealthScoreStatus(team?.scoring_avg_adjusted_nba, categories);
	} else if (type === 'defense') {
		categories = [];
		return checkHealthScoreStatus(team?.defense_avg_adjusted_nba, categories);
	} else {
		return categories;
	}
}

// Unused Function
export function getHealthScoreAvg(playerArr, type, healthScores, avg) {
	let playerAvg = avg;
	if (!playerAvg) {
		playerAvg = playerArr.reduce(function (previousValue, currentValue) {
			return previousValue + currentValue.gaming_score;
		}, 0);
		playerAvg = playerAvg / playerArr.length;
	}
	let maxValue, minValue;
	if (!healthScores) {
		return 0;
	}
	const scoreType = healthScores?.categoryAverages;
	if (scoreType) {
		if (type === 'offensiveskills') {
			maxValue = scoreType.offensiveSkills.max;
			minValue = scoreType.offensiveSkills.min;
		} else if (type === 'offensiveline') {
			maxValue = scoreType.offensiveLine.max;
			minValue = scoreType.offensiveLine.min;
		} else if (type === 'defensiveline') {
			maxValue = scoreType.defensiveLine.max;
			minValue = scoreType.defensiveLine.min;
		} else if (type === 'defensivesecondary') {
			maxValue = scoreType.defensiveSecondary.max;
			minValue = scoreType.defensiveSecondary.min;
		} else if (type === 'rebounders') {
			maxValue = scoreType?.rebounders?.max;
			minValue = scoreType?.rebounders?.min;
		} else if (type === 'scorers') {
			maxValue = scoreType?.scorers?.max;
			minValue = scoreType?.scorers?.min;
		} else if (type === 'defense') {
			maxValue = scoreType?.defense?.max;
			minValue = scoreType?.defense?.min;
		}
	} else {
		return;
	}
	const range = maxValue - minValue;
	playerAvg = ((range - (maxValue - playerAvg)) / range) * 10;
	return playerAvg.toFixed(2);
}

export function sortPlayersByGamingScore(players) {
	// Pick one best player per key position.
	// Priority: lowest depth_chart_order (starter) → fallback: highest gaming_score
	const slots = {
		QB: null, WR: null, RB: null, TE: null,
		DE: null, CB: null, SS: null, FS: null, S: null, LB: null, OLB: null, MLB: null,
	};

	for (const player of players) {
		const pos = player.position_map || player.position;
		if (!(pos in slots)) continue;

		const current = slots[pos];
		if (!current) {
			slots[pos] = player;
			continue;
		}

		const currDepth = current.depth_chart_order > 0 ? current.depth_chart_order : null;
		const nextDepth = player.depth_chart_order > 0 ? player.depth_chart_order : null;

		if (nextDepth !== null && currDepth !== null) {
			if (nextDepth < currDepth) slots[pos] = player;
		} else if (nextDepth !== null && currDepth === null) {
			slots[pos] = player;
		} else if (nextDepth === null && currDepth === null) {
			if ((player.gaming_score || 0) > (current.gaming_score || 0)) slots[pos] = player;
		}
	}

	return Object.values(slots).filter(Boolean);
}

export function sortTopNBAPlayers(players) {
	let sortedPlayers = players;
	let ppg, ppg_2, rpg, assists;
	let playerName = [];
	// 1. Top Scorer (PPG)
	// 2. Top rebounder (RPG)
	// 3. Top assists (APG)
	// 4. 2nd scorer

	sortedPlayers.sort(sortArrayOfObj('ppg_avg', 'desc'));
	sortedPlayers.map((x) => {
		if (!ppg || ppg < x.ppg_avg) {
			ppg = x;
			playerName.push(x.nickname || x.player_name);
		}
	});
	sortedPlayers.map((x) => {
		if (!playerName.includes(x.nickname || x.player_name) && (!ppg_2 || ppg_2 < x.ppg_avg)) {
			ppg_2 = x;
			playerName.push(x.nickname || x.player_name);
		}
	});
	sortedPlayers.sort(sortArrayOfObj('rpg_avg', 'desc'));
	sortedPlayers.map((x) => {
		if (!playerName.includes(x.nickname || x.player_name) && (!rpg || rpg < x.rpg_avg)) {
			rpg = x;
			playerName.push(x.nickname || x.player_name);
		}
	});
	sortedPlayers.sort(sortArrayOfObj('assists_avg', 'desc'));
	sortedPlayers.map((x) => {
		if (!playerName.includes(x.nickname || x.player_name) && (!assists || assists < x.assists_avg)) {
			assists = x;
			playerName.push(x.nickname || x.player_name);
		}
	});

	sortedPlayers = [];
	sortedPlayers.push(ppg);
	sortedPlayers.push(ppg_2);
	sortedPlayers.push(rpg);
	sortedPlayers.push(assists);
	return sortedPlayers;
}

// export function sortTopSoccerPlayers(players) {
// 	if (!Array.isArray(players)) return [];
// 	console.log(players,'players....');
// 	const categories = [
// 		{ key: 'Goalkeeper', values: ['GK', 'G', 'Goalkeeper'] },
// 		{ key: 'Defender', values: ['DF', 'Defender', 'D'] },
// 		{ key: 'Midfielder', values: ['MF', 'Midfielder', 'M'] },
// 		{ key: 'Forward', values: ['FW', 'Forward', 'F'] },
// 	];
// 	const topPlayers = categories.map(cat => {
// 		const playersInCat = players.filter(p =>
// 			cat.values.includes((p.position_category || p.position || '').toString().trim())
// 		);
// 		if (!playersInCat.length) return undefined;
// 		return playersInCat.sort((a, b) => (b.gaming_score || 0) - (a.gaming_score || 0))[0];
// 	}).filter(Boolean);
// 	console.log(topPlayers,'topPlayers')
// 	return topPlayers;
// }
export function sortTopSoccerPlayers(allPlayers, topPlayers) {
	if (!Array.isArray(allPlayers) || !Array.isArray(topPlayers)) return [];

	const positionOrder = [
		{ key: 'Goalkeeper', label: 'GK' },
		{ key: 'Defender', label: 'DF' },
		{ key: 'Midfielder', label: 'MF' },
		{ key: 'Forward', label: 'FW' },
	];

	const positionRank = Object.fromEntries(positionOrder.map((p, i) => [p.key, i]));
	const positionLabelMap = Object.fromEntries(positionOrder.map(p => [p.key, `${p.key} - ${p.label}`]));

	const topMap = new Map(topPlayers.map(p => [p.player_id, p.position]));
	const allPlayersMap = new Map(allPlayers.map(p => [p.player_id, p]));

	const enrichedPlayers = topPlayers
		.map(tp => {
			const full = allPlayersMap.get(tp.player_id);
			if (!full) return null;
			const position = topMap.get(tp.player_id);
			return {
				...full,
				position,                             // override position
				position_label: positionLabelMap[position] || position // e.g. "Goalkeeper - GK"
			};
		})
		.filter(Boolean);

	// Sort by position rank
	return enrichedPlayers.sort(
		(a, b) => (positionRank[a.position] ?? 99) - (positionRank[b.position] ?? 99)
	);
}




export function betOnGame(pointSpread, injurySpread) {
	let pointDiff;

	if (pointSpread >= 0 && injurySpread >= 0 && pointSpread > injurySpread) {
		pointDiff = pointSpread - injurySpread;
	} else if (pointSpread >= 0 && injurySpread >= 0 && pointSpread < injurySpread) {
		pointDiff = injurySpread - pointSpread;
	} else if (pointSpread < 0 && injurySpread < 0 && pointSpread > injurySpread) {
		pointDiff = pointSpread + -1 * injurySpread;
	} else if (pointSpread < 0 && injurySpread < 0 && pointSpread < injurySpread) {
		pointDiff = injurySpread + -1 * pointSpread;
	''} else if (pointSpread > 0 && injurySpread < 0 && pointSpread > 0.5) {
		pointDiff = 1;
	} else if (pointSpread < 0 && injurySpread > 0 && injurySpread > 0.5) {
		pointDiff = 1;
	} else if (pointSpread > 0 && injurySpread < 0) {
		pointDiff = injurySpread + pointSpread;
	}
	if (pointDiff < 0.6) {
		return false;
	}
	return true;
}

export function calculatePointSpread(pointSpread) {
	let newPointSpread = pointSpread % 1;

	if (newPointSpread >= 0 && newPointSpread < 0.26) {
		newPointSpread = Math.floor(pointSpread);
	} else if (newPointSpread >= 0.26 && newPointSpread < 0.75) {
		newPointSpread = pointSpread - newPointSpread + 0.5;
	} else if (newPointSpread >= 0.75) {
		newPointSpread = Math.ceil(pointSpread);
	} else if (newPointSpread <= 0 && newPointSpread > -0.26) {
		newPointSpread = Math.ceil(pointSpread);
	} else if (newPointSpread <= -0.26 && newPointSpread > -0.75) {
		newPointSpread = pointSpread - newPointSpread - 0.5;
	} else if (newPointSpread <= -0.74) {
		newPointSpread = Math.floor(pointSpread);
	}
	if (newPointSpread > 0) {
		return '-' + newPointSpread;
	}
	return newPointSpread;
}

export function calculateInjuryPointSpread(pointSpread, injurySpread) {
	let newInjurySpread = injurySpread % 1;
	if (newInjurySpread >= 0 && newInjurySpread < 0.26) {
		newInjurySpread = Math.floor(injurySpread);
	} else if (newInjurySpread >= 0.26 && newInjurySpread < 0.75) {
		newInjurySpread = injurySpread - newInjurySpread + 0.5;
	} else if (newInjurySpread >= 0.75) {
		newInjurySpread = Math.ceil(injurySpread);
	} else if (newInjurySpread <= 0 && newInjurySpread > -0.26) {
		newInjurySpread = Math.ceil(injurySpread);
	} else if (newInjurySpread <= -0.26 && newInjurySpread > -0.75) {
		newInjurySpread = injurySpread - newInjurySpread - 0.5;
	} else if (newInjurySpread <= -0.74) {
		newInjurySpread = Math.floor(injurySpread);
	}

	const teamHighlight = highlightColumn(pointSpread, injurySpread);

	if (!betOnGame(pointSpread, injurySpread)) {
		if (newInjurySpread >= 0) {
			return newInjurySpread * -1;
		} else {
			return newInjurySpread;
		}
	}

	if (newInjurySpread === 0) {
		return newInjurySpread;
	} else if (teamHighlight === 'home' && pointSpread >= 0 && injurySpread < 0) {
		return '*' + newInjurySpread;
	} else if (teamHighlight === 'home' && pointSpread < 0 && injurySpread >= 0) {
		return '*' + newInjurySpread * -1;
	} else if (teamHighlight === 'home' && pointSpread < 0 && injurySpread >= 0) {
		return '+' + newInjurySpread * -1;
	} else if (teamHighlight === 'home' && pointSpread >= 0) {
		return '+' + newInjurySpread;
	} else if (teamHighlight === 'home' && pointSpread < 0) {
		return newInjurySpread;
	} else if (teamHighlight === 'away' && pointSpread < 0 && injurySpread >= 0) {
		return '*' + newInjurySpread * -1;
	} else if (teamHighlight === 'away' && pointSpread >= 0 && injurySpread < 0) {
		return '*' + newInjurySpread;
	} else if (teamHighlight === 'away' && pointSpread >= 0) {
		return '-' + newInjurySpread;
	} else if (teamHighlight === 'away' && pointSpread < 0) {
		return '+' + newInjurySpread * -1;
	}
}

export function showHealthyToReturnDate(date, months) {
	const currentDate = new Date();
	if (monthDifference(new Date(date), currentDate) > months && new Date(date) < currentDate) {
		return false;
	}
	return true;
}

// New function to check if player should be marked as fully recovered based on 3-month expiry
export function isPlayerFullyRecovered(playerInfo, sportsID) {
	if (!playerInfo) return false;

	// A player with an active injury designation is never fully recovered
	const INJURED_STATUSES = ['out', 'questionable', 'doubtful', 'probable', 'ir', 'inactive', 'injured', 'day-to-day', 'gtd'];
	if (playerInfo.injury_status && INJURED_STATUSES.includes(String(playerInfo.injury_status).toLowerCase().trim())) {
		return false;
	}

	const currentDate = new Date();

	// NBA only: use the highest of all available dates, expire at 3 months
	if (sportsID === 2) {
		const dateCandidates = [];
		if (playerInfo.recovery_return_date) {
			dateCandidates.push(new Date(playerInfo.recovery_return_date));
		}
		if (playerInfo.expected_return && String(playerInfo.expected_return).trim() !== '' && playerInfo.expected_return !== 'null') {
			dateCandidates.push(new Date(playerInfo.expected_return));
		}
		if (playerInfo.full_recovery_date_by_team) {
			dateCandidates.push(new Date(playerInfo.full_recovery_date_by_team));
		}
		if (dateCandidates.length > 0) {
			const highestDate = new Date(Math.max(...dateCandidates.map(d => d.getTime())));
			if (monthDifference(highestDate, currentDate) >= 3 && highestDate < currentDate) {
				return true;
			}
			return false;
		}
		return false;
	}

	// All other sports: existing logic unchanged
	if (playerInfo.recovery_return_date) {
		const returnDate = new Date(playerInfo.recovery_return_date);
		const monthsSinceReturn = monthDifference(returnDate, currentDate);
		if (monthsSinceReturn >= 2 && returnDate < currentDate) {
			return true;
		}
	}

	if (playerInfo.injury_date) {
		const injuryDate = new Date(playerInfo.injury_date);
		const monthsSinceInjury = monthDifference(injuryDate, currentDate);
		if (monthsSinceInjury >= 2 && injuryDate < currentDate && !playerInfo.recovery_return_date) {
			return true;
		}
	}

	return false;
}

export const getMappedBodyPart = (history) => {
	const specialBodyParts = ["ACHILLES", "ACL"];
	if (history.injury_description) {
	  const desc = history.injury_description.toUpperCase();
	  for (const part of specialBodyParts) {
		if (desc.includes(part)) {
		  return part; // Return the matched special body part
		}
	  }
	}
	return history.body_part; // If no special body part is found, return the original body part
};

export const getMappedBodyPartFromPlayer = (history) => {
	const specialBodyParts = ["ACHILLES", "ACL"];
	if (history?.injury_notes) {
	  const desc = history.injury_notes.toUpperCase();
	  for (const part of specialBodyParts) {
		if (desc.includes(part)) {
		  return part; // Return the matched special body part
		}
	  }
	}
	return history?.body_part || ''; // If no special body part is found, return the original body part
};

export function calculateHeight(height) {
	let feet = Math.floor(height / 12);
	let inches = Math.floor(height % 12);
	return isNaN(feet) || isNaN(inches) ? height : `${feet}'${inches}"`;
}

export function getUserSubscription(user, type) {
	if (!user || !type) {
		return false;
	}
	if (user.login && user.paid && user.package_plan) {
		return user.package_plan.toUpperCase() === type;
	} else {
		return false;
	}
}

// Returns the most impactful NBA player for each position: PG, SG, SF, PF, C
export function getTopNBAPlayersByPosition(players) {
    const positions = ['PG', 'SG', 'SF', 'PF', 'C'];
    return positions.map(pos => {
        // Filter players for this position (case-insensitive, trims spaces)
        const playersForPosition = players.filter(
            p => p.position && p.position.replace(/\s+/g, '').toUpperCase() === pos
        );
        if (playersForPosition.length === 0) return null;
        // Sort by ppg_avg descending and take the top
        playersForPosition.sort((a, b) => (b.ppg_avg || 0) - (a.ppg_avg || 0));
        return playersForPosition[0];
    });
}
